/**
 * Triggers file download in the browser
 * @param {Blob} blob - The file data as a Blob
 * @param {string} fileName - Name for the downloaded file
 */
export const downloadFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Generates a filename with timestamp
 * @param {string} baseName - Base name for the file
 * @param {string} extension - File extension (without dot)
 * @returns {string} Formatted filename
 */
export const generateFileName = (baseName, extension) => {
  const timestamp = new Date().toISOString().split('T')[0];
  return `${baseName}_${timestamp}.${extension}`;
};

export const downloadJsonFile = (data, fileNamePrefix = 'data') => {
  if (!data) {
    console.error('No data provided for download.');
    return;
  }

  try {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const fileName = `${fileNamePrefix}_${timestamp}.json`;
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(link.href); // Clean up
    
    return fileName; // Return the generated file name
  } catch (error) {
    console.error('Error generating or downloading JSON file:', error);
    throw new Error('Failed to download JSON data.');
  }
}; 